import acceptedCookiePolicy from "../../../components/onetrust/cookiePolicy";
import logAmplitudeEvent from "../../../components/amplitude";

const logRemovedSavedJobFromSavedJobsPage = (jobID) => {
    const jobContainer = document.querySelector(`[data-ghid="${jobID}"]`) || null;
    const jobTitle = jobContainer.querySelector('.title').innerText || null;
    const jobDepartment = jobContainer.querySelector('.coveo-main-badge.career span').innerText || null;
    const jobLocation = jobContainer.querySelector('[data-icon="location"]').innerText || null;
    const jobEmploymentType = jobContainer.querySelector('[data-icon="employment-type"]').innerText || null;
    const interactionUrl = location.href.split('?')[0] || null;
    acceptedCookiePolicy({
        ifPerformanceCookies: () => {
            if (OnetrustActiveGroups.includes("C0004")) {
                if (jobContainer) {
                    logAmplitudeEvent({
                        event_type: "Job Unsaved",
                        properties: {
                            job_title: jobTitle,
                            job_location: jobLocation,
                            job_department: jobDepartment,
                            job_employment_type: jobEmploymentType,
                            url: interactionUrl
                        }
                    })
                }
            }
        }
    })
}

const logSaveJobFromJobDetailsPage = () => {
    const jobListingTitle = document.querySelector('.hero-job-detail .heading') || null;
    const jobListingDepartment = document.querySelector('.hero-job-detail .department') || null;
    const jobListingLocation = document.querySelector('.hero-job-detail .location') || null;
    const jobListingEmployementType = document.querySelector('.hero-job-detail .employment-type') || null;
    const jobListingUrl = location.href.split("?")[0] || null;
    acceptedCookiePolicy({
        ifPerformanceCookies: () => {
            if (OnetrustActiveGroups.includes("C0004")) {
                logAmplitudeEvent({
                    event_type: "Job Saved",
                    properties: {
                        job_title: jobListingTitle,
                        job_location: jobListingLocation,
                        job_department: jobListingDepartment,
                        job_employment_type: jobListingEmployementType,
                        url: jobListingUrl
                    }
                })
            }
        }
    })
}

const logUnSaveJobFromJobDetailsPage = () => {
    const jobListingTitle = document.querySelector('.hero-job-detail .heading') || null;
    const jobListingDepartment = document.querySelector('.hero-job-detail .department') || null;
    const jobListingLocation = document.querySelector('.hero-job-detail .location') || null;
    const jobListingEmployementType = document.querySelector('.hero-jbo-detail .employment-type') || null;
    const jobListingUrl = location.href.split("?")[0] || null;
    acceptedCookiePolicy({
        ifPerformanceCookies: () => {
            if (OnetrustActiveGroups.includes("C0004")) {
                logAmplitudeEvent({
                    event_type: "Job Unsaved",
                    properties: {
                        job_title: jobListingTitle,
                        job_location: jobListingLocation,
                        job_department: jobListingDepartment,
                        job_employment_type: jobListingEmployementType,
                        url: jobListingUrl
                    }
                })
            }
        }
    })
}

const logSaveorUnsaveJobFromCareersResultPage = (event) => {
    const jobListingContainer = event.target.closest('div.coveo-list-layout.CoveoResult') || null;
    acceptedCookiePolicy({
        ifPerformanceCookies: () => {
            if (OnetrustActiveGroups.includes("C0004")) {
                if (jobListingContainer) {
                    const jobListingTitle = jobListingContainer.querySelector('h5.title').innerText || null;
                    const jobListingDepartment = jobListingContainer.querySelector('span.coveo-main-badge.career').innerText || null;
                    const jobListingLocation = jobListingContainer.querySelector('[data-icon="location"]').innerText || null;
                    const jobListingEmployementType = jobListingContainer.querySelector('[data-icon="employment-type"]').innerText || null;
                    const interactionUrl = location.href.split('?')[0] || null;
                    const savedJobIconDiv = jobListingContainer.querySelector('div.saved-jobs-icon');

                    if (savedJobIconDiv.classList.contains('is-saved')) {
                        logAmplitudeEvent({
                            event_type: "Job Saved",
                            properties: {
                                job_title: jobListingTitle,
                                job_location: jobListingLocation,
                                job_department: jobListingDepartment,
                                job_employment_type: jobListingEmployementType,
                                url: interactionUrl
                            }
                        });
                    } else {
                        logAmplitudeEvent({
                            event_type: "Job Unsaved",
                            properties: {
                                job_title: jobListingTitle,
                                job_location: jobListingLocation,
                                job_department: jobListingDepartment,
                                job_employment_type: jobListingEmployementType,
                                url: interactionUrl
                            }
                        });
                    }
                }
            }
        }
    })
}

export { logRemovedSavedJobFromSavedJobsPage, logSaveJobFromJobDetailsPage, logUnSaveJobFromJobDetailsPage, logSaveorUnsaveJobFromCareersResultPage }